import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "verification-page" }
const _hoisted_2 = { class: "verification-content" }
const _hoisted_3 = { class: "input-section" }
const _hoisted_4 = { class: "scan-section" }
const _hoisted_5 = { class: "scan-tips" }
const _hoisted_6 = {
  key: 0,
  class: "scanner-section"
}
const _hoisted_7 = { class: "scanner-overlay" }
const _hoisted_8 = { class: "scan-guide" }
const _hoisted_9 = { class: "scanner-actions" }
const _hoisted_10 = {
  key: 1,
  class: "result-section"
}
const _hoisted_11 = { class: "status-icon" }
const _hoisted_12 = { class: "status-content" }
const _hoisted_13 = { class: "status-title" }
const _hoisted_14 = { class: "status-message" }
const _hoisted_15 = { class: "scan-info-card" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = { class: "info-grid" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = { class: "scan-count" }
const _hoisted_21 = {
  key: 0,
  class: "info-item"
}
const _hoisted_22 = { class: "scan-time" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "scan-time" }
const _hoisted_25 = {
  key: 0,
  class: "commodity-card"
}
const _hoisted_26 = { class: "card-title" }
const _hoisted_27 = { class: "commodity-content" }
const _hoisted_28 = {
  key: 0,
  class: "commodity-image"
}
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { class: "commodity-details" }
const _hoisted_31 = { class: "commodity-name" }
const _hoisted_32 = { class: "commodity-specs" }
const _hoisted_33 = {
  key: 0,
  class: "spec-item"
}
const _hoisted_34 = {
  key: 1,
  class: "spec-item"
}
const _hoisted_35 = {
  key: 2,
  class: "spec-item"
}
const _hoisted_36 = {
  key: 3,
  class: "spec-item"
}
const _hoisted_37 = {
  key: 4,
  class: "spec-item"
}
const _hoisted_38 = {
  key: 5,
  class: "spec-item"
}
const _hoisted_39 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_40 = { class: "overlay-content" }

import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast } from 'vant'
import { verifyProduct } from '@/api/verification'
import { getUserLang } from '@/storage/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'Guard',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()

// 响应式数据
const securityCode = ref('')
watch(() => securityCode.value, (code) => {
  if (code) {
    handleManualVerification(code)
  }
})
const errorMessage = ref('')
const verifying = ref(false)
const scanning = ref(false)
const showScanner = ref(false)
const hasSearched = ref(false)
const verificationResult = ref<any>(null)
const scannerContainer = ref<HTMLElement>()
let html5QrCode: any = null

// 设备类型检测
const deviceType = computed(() => {
  const width = window.innerWidth
  const height = window.innerHeight

  if (width >= 1200) {
    return 'pc'
  } else if (width >= 768) {
    return 'tablet'
  } else if (width >= 1080 && height >= 1920) {
    return 'large-mobile'
  } else {
    return 'mobile'
  }
})

// 方法
const validateSecurityCode = (code: string): boolean => {
  if (!code) {
    errorMessage.value = t('verification.codeRequired')
    return false
  }

  if (code.length < 8) {
    errorMessage.value = t('verification.codeTooShort')
    return false
  }

  errorMessage.value = ''
  return true
}

const handleManualVerification = async () => {
  if (!validateSecurityCode(securityCode.value)) {
    return
  }

  // const params = {
  //   code: securityCode.value
  // }
  verifyProduct(securityCode.value).then(res => {
    verificationResult.value = res
  })
}

const handleDemoVerify = () => {
  const lang = getUserLang()
  securityCode.value = lang === 'en-US' ? 'C428CE5E8BC245E38C97766E3B8FE801' : '5AD6C4EED48D4DF0A381B6DA7D0B926F'
}

const onScanSuccess = (decodedText: string) => {
  // 停止扫码
  stopScan()

  // 将扫码结果填入输入框
  securityCode.value = decodedText

  // 自动开始验证
  handleManualVerification()

  showToast(t('verification.scanSuccess'))
}

const onScanFailure = (error: string) => {
  // 扫码失败的处理，通常是继续扫描
  console.log('Scan failed:', error)
}

const stopScan = () => {
  if (html5QrCode) {
    html5QrCode.stop().then(() => {
      html5QrCode.clear()
      html5QrCode = null
    }).catch((error: any) => {
      console.error('Failed to stop scanner:', error)
    })
  }

  showScanner.value = false
  scanning.value = false
}

const getStatusClass = (result: any) => {
  if (result.isFirstScan) {
    return 'status-first-scan'
  } else if (result.scanTimes <= 2) {
    return 'status-normal'
  } else {
    return 'status-multiple-scans'
  }
}

const getStatusIcon = (result: any) => {
  if (result.isFirstScan) {
    return 'certificate'
  } else {
    return 'shield'
  }
}

const getStatusTitle = (result: any) => {
  if (result.isFirstScan) {
    return t('verification.authenticProduct')
  } else {
    return t('verification.verifiedProduct')
  }
}

const formatDate = (dateString: string | Date) => {
  const date = new Date(dateString)
  const lang = getUserLang()
  return new Intl.DateTimeFormat(lang, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date)
}

const handleImageLoad = () => {
  // 图片加载成功
}

const handleImageError = () => {
  console.error('商品图片加载失败')
}

const resetSearch = () => {
  securityCode.value = ''
  errorMessage.value = ''
  verificationResult.value = null
  hasSearched.value = false
}

const route = useRoute()
// 生命周期
onMounted(() => {
  // 可以在这里添加初始化逻辑
  securityCode.value = route.query.code as string
})

onUnmounted(() => {
  // 清理扫码器
  if (html5QrCode) {
    stopScan()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: securityCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((securityCode).value = $event)),
          placeholder: _ctx.$t('verification.enterCode'),
          clearable: "",
          maxlength: "50",
          "error-message": errorMessage.value,
          class: "code-input"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "small",
              type: "primary",
              loading: verifying.value,
              class: "verify-btn",
              onClick: handleManualVerification
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('verification.verify')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "error-message"]),
        (!securityCode.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_van_button, {
                  block: "",
                  type: "primary",
                  size: "large",
                  loading: scanning.value,
                  class: "scan-btn",
                  onClick: handleDemoVerify
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('verification.demoCode')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_van_icon, { name: "info" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('verification.demoTip')), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (showScanner.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              ref_key: "scannerContainer",
              ref: scannerContainer,
              class: "scanner-container"
            }, null, 512),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"scan-frame\" data-v-27570c8a><div class=\"frame-corner top-left\" data-v-27570c8a></div><div class=\"frame-corner top-right\" data-v-27570c8a></div><div class=\"frame-corner bottom-left\" data-v-27570c8a></div><div class=\"frame-corner bottom-right\" data-v-27570c8a></div></div>", 1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('verification.scanGuide')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_button, {
                round: "",
                type: "default",
                icon: "cross",
                class: "close-scanner-btn",
                onClick: stopScan
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (verificationResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["status-card", getStatusClass(verificationResult.value)])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_van_icon, {
                  name: getStatusIcon(verificationResult.value)
                }, null, 8, ["name"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h3", _hoisted_13, _toDisplayString(getStatusTitle(verificationResult.value)), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(verificationResult.value.message), 1)
              ])
            ], 2),
            (verificationResult.value?.exists)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('verification.scanInfo')), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.isFirstScan')), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'first-scan': verificationResult.value.isFirstScan })
                        }, _toDisplayString(verificationResult.value.isFirstScan ? _ctx.$t('verification.yes') : _ctx.$t('verification.no')), 3)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.scanTimes')), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(verificationResult.value.scanTimes), 1)
                      ]),
                      (verificationResult.value.firstScanTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.firstScanTime')), 1),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(verificationResult.value.firstScanTime)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.currentScanTime')), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(formatDate(new Date())), 1)
                      ])
                    ])
                  ]),
                  (verificationResult.value.commodityInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.$t('verification.commodityInfo')), 1),
                        _createElementVNode("div", _hoisted_27, [
                          (verificationResult.value.commodityInfo.stylePhotoProxy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("img", {
                                  src: verificationResult.value.commodityInfo.stylePhotoProxy,
                                  alt: verificationResult.value.commodityInfo.styleDescription,
                                  onLoad: handleImageLoad,
                                  onError: handleImageError
                                }, null, 40, _hoisted_29)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("h5", _hoisted_31, _toDisplayString(verificationResult.value.commodityInfo.styleDescription || _ctx.$t('verification.unknownProduct')), 1),
                            _createElementVNode("div", _hoisted_32, [
                              (verificationResult.value.commodityInfo.styleNo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.styleNo')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.styleNo), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (verificationResult.value.commodityInfo.sptColor)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.color')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.sptColor), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (verificationResult.value.commodityInfo.sizeName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.size')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.sizeName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (verificationResult.value.commodityInfo.stockType)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.category')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.stockType), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (verificationResult.value.commodityInfo.country)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.country')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.country), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (verificationResult.value.commodityInfo.collectionNo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('verification.collection')), 1),
                                    _createElementVNode("span", null, _toDisplayString(verificationResult.value.commodityInfo.collectionNo), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (hasSearched.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createVNode(_component_van_empty, {
                description: _ctx.$t('verification.noResult'),
                image: "search"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    round: "",
                    type: "primary",
                    onClick: resetSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('verification.tryAgain')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["description"])
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_overlay, {
      show: verifying.value,
      class: "verifying-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_van_loading, {
            size: "24px",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('verification.verifying')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})